import ItemPlugin from "./ImageItem/ImageItem";
import { processRawInput } from "./processRawInput";

export default function registerImagePlugin() {
  return { ItemPlugin, processRawInput };
}
